export enum LoanPurposeEnum {
  HOUSEHOLD_APPLIANCES = 'HOUSEHOLD_APPLIANCES',
  HOME_REPAIR = 'HOME_REPAIR',
  TUITION = 'TUITION',
  UTILITIES = 'UTILITIES',
  MEDICAL = 'MEDICAL',
  GROCERIES = 'GROCERIES',
  CLOTHING = 'CLOTHING',
  ENTERTAINMENT = 'ENTERTAINMENT',
  GAMBLING = 'GAMBLING',
  REPAYMENT = 'REPAYMENT',
}
